/* eslint "import/no-mutable-exports": "off" */
const eeTypes = [
  { type: 'WORKER', title: 'job_position.worker', intl: true },
  { type: 'SPECIALIST_OFFICE_WORKER', title: 'job_position.specialist_office_worker', intl: true },
  { type: 'SENIOR_SPECIALIST', title: 'job_position.senior_specialist', intl: true },
  { type: 'MIDDLE_MANAGER', title: 'job_position.middle_manager', intl: true },
  { type: 'TOP_MANAGER', title: 'job_position.top_manager', intl: true },
  {
    type: 'OWNER_OF_COMPANY_SHAREHOLDER',
    title: 'job_position.owner_of_company_shareholder',
    intl: true,
  },
  { type: 'WORKING_STUDENT', title: 'job_position.working_student', intl: true },
];

const lvTypes = [
  { type: 'EMPLOYEE', title: 'job_position.employee', intl: true },
  { type: 'MANAGER', title: 'job_position.manager', intl: true },
  { type: 'EXECUTIVE', title: 'job_position.executive', intl: true },
  { type: 'SPECIALIST', title: 'job_position.specialist', intl: true },
  { type: 'OFFICE_CLERK', title: 'job_position.office_clerk', intl: true },
  { type: 'OTHER', title: 'job_position.other', intl: true },
];

const fiTypes = [
  { type: 'EMPLOYEE', title: 'job_position.employee', intl: true },
  { type: 'MANAGER', title: 'job_position.manager', intl: true },
  { type: 'LOWER_OFFICIAL', title: 'job_position.lower_official', intl: true },
  { type: 'HIGHER_OFFICIAL', title: 'job_position.higher_official', intl: true },
  { type: 'EXECUTIVE', title: 'job_position.executive', intl: true },
  { type: 'OTHER', title: 'job_position.other', intl: true },
];

const mxTypes = [
  { type: 'ALIMONY', title: 'job_position.alimony', intl: true },
  { type: 'GAMBLING', title: 'job_position.gambling', intl: true },
  { type: 'AUTOMOTIVE', title: 'job_position.automotive', intl: true },
  { type: 'WEAPONS_TRADING', title: 'job_position.weapons_trading', intl: true },
  { type: 'FOREIGN_CURRENCY_EXCHANGE', title: 'job_position.foreign_currency_exchange', intl: true },
  { type: 'ART_JEWELRY_TRADING', title: 'job_position.art_jewelry_trading', intl: true },
  { type: 'CONSTRUCTION', title: 'job_position.construction', intl: true },
  { type: 'ADULT_ENTERTAINMENT', title: 'job_position.adult_entertainment', intl: true },
  { type: 'HOTEL_RESTAURANTS_AND_LEISURE', title: 'job_position.hotel_restaurants_and_leisure', intl: true },
  { type: 'RECYCLING', title: 'job_position.recycling', intl: true },
  { type: 'SERVICES', title: 'job_position.services', intl: true },
  { type: 'FINANCIAL_SERVICES', title: 'job_position.financial_services', intl: true },
  { type: 'WHOLESALE_TRADE', title: 'job_position.wholesale_trade', intl: true },
  { type: 'RETAIL_TRADE', title: 'job_position.retail_trade', intl: true },
];

const esTypes = [
  { type: 'EXECUTIVE', title: 'job_position.executive', intl: true },
  { type: 'GOVERNMENT_OFFICIAL', title: 'job_position.government_official', intl: true },
  { type: 'HIGHER_OFFICIAL', title: 'job_position.higher_official', intl: true },
  { type: 'LOWER_OFFICIAL', title: 'job_position.lower_official', intl: true },
  { type: 'MANAGER', title: 'job_position.manager', intl: true },
  { type: 'MIDDLE_MANAGER', title: 'job_position.middle_manager', intl: true },
  { type: 'OFFICE_CLERK', title: 'job_position.office_clerk', intl: true },
  { type: 'OTHER', title: 'job_position.other', intl: true },
  { type: 'OWNER_OF_COMPANY_SHAREHOLDER', title: 'job_position.owner_of_company_shareholder', intl: true },
  { type: 'SENIOR_SPECIALIST', title: 'job_position.senior_specialist', intl: true },
  { type: 'SPECIALIST', title: 'job_position.specialist', intl: true },
  { type: 'SPECIALIST_OFFICE_WORKER', title: 'job_position.specialist_office_worker', intl: true },
  { type: 'TOP_MANAGER', title: 'job_position.top_manager', intl: true },
  { type: 'WORKER', title: 'job_position.worker', intl: true },
  { type: 'WORKING_STUDENT', title: 'job_position.working_student', intl: true },
];

let data = [];

switch (COUNTRY) {
  case 'LV':
    data = data.concat(lvTypes);
    break;
  case 'FI':
    data = data.concat(fiTypes);
    break;
  case 'MX':
    data = data.concat(mxTypes);
    break;
  case 'ES':
    data = data.concat(esTypes);
    break;
  default:
    data = data.concat(eeTypes);
}

export default data;
